<p-confirmDialog key="schoolmaintconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="schoolmaintstatus" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ItemMenu">
	<h4 style="text-align: center">School User Summary</h4>

	<!--Show Role Types-->
	<div class="Grid2Col" style="margin-top: 15px">
		<label>Show Roles for:</label>

		<div class="CheckGrid4Col">
			<input
				[disabled]="IsLoading() == true"
				type="checkbox"
				class="CHK"
				id="ShowCAASS"
				[(ngModel)]="ShowCAASS"
				(ngModelChange)="onShowCAASSChange($event)"
			/>
			<label for="ShowCAASS">CAASS</label>

			<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" id="ShowVPP" [(ngModel)]="ShowVPP" (ngModelChange)="onShowVPPChange($event)" />
			<label for="ShowVPP">VPP</label>

			<input
				[disabled]="IsLoading() == true"
				type="checkbox"
				class="CHK"
				id="ShowMulti"
				[(ngModel)]="ShowMulti"
				(ngModelChange)="onShowMultiChange($event)"
			/>
			<label for="ShowMulti">CAASS Visitors</label>

			<input
				[disabled]="IsLoading() == true"
				type="checkbox"
				class="CHK"
				id="ShowTransit"
				[(ngModel)]="ShowTransit"
				(ngModelChange)="onShowTransitChange($event)"
			/>
			<label for="ShowTransit">Transit</label>
		</div>
	</div>

	<div style="justify-content: center; display: grid; margin-top: 15px">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onExportSchools()">Export</button>
	</div>

	<!--Table-->
	<div style="margin-top: 15px">
		<p-table
			#mydt
			[value]="lstSchool"
			[loading]="LoadingSchool == true"
			[paginator]="true"
			[(rows)]="schoolpagerows"
			[(first)]="schoolpagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedSchool"
			dataKey="SchoolID"
			(onRowSelect)="onSchoolRowSelect($event)"
			(onRowUnselect)="onSchoolRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--SchoolName-->
					<th>
						<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SchoolNumber-->
					<th>
						<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<th *ngFor="let role of lstRoleNames">
						<p-columnFilter type="numeric" matchMode="gte" [field]="role.RoleName" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="SchoolName">Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
					<th pSortableColumn="SchoolNumber">Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
					<th [pSortableColumn]="role.RoleName" *ngFor="let role of lstRoleNames">
						{{ role.RoleDesc }} <p-sortIcon [field]="role.RoleName"></p-sortIcon>
					</th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-School>
				<tr [pSelectableRow]="School">
					<td *ngFor="let col of SchoolCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ School[col.field] }}
					</td>
					<td *ngFor="let role of School.lstSelectedRoles" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ role.UserCount }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<div *ngIf="SelectedSchool != undefined" class="ItemMenu">
	<h4 style="text-align: center">Users By Role</h4>

	<!--Menu Bar-->
	<div class="button-body MenuBar">
		<div class="Grid2Col">
			<label>Role:</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control"
				name="SelectedRole"
				[(ngModel)]="SelectedRole"
				(ngModelChange)="onSelectedRoleChange($event)"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstRoleNames" [ngValue]="o">{{ o.RoleDesc }}</option>
			</select>
		</div>

		<!--Buttons-->
		<div class="flex">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onUserRefresh()">Refresh</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddUsers()">Add Users</button>
			<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onRemoveUsers()">Remove Users</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onExportRole()">Export</button>
		</div>
	</div>

	<!--User Table-->
	<div style="margin-top: 15px">
		<p-table
			#mydt
			[value]="lstUsers"
			[loading]="LoadingUser == true"
			[paginator]="true"
			[(rows)]="userpagerows"
			[(first)]="userpagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedUsers"
			dataKey="UserID"
			(onRowSelect)="onUserRowSelect($event)"
			(onRowUnselect)="onUserRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--INSERT CUSTOM FILTERS HERE-->

					<!--UserName-->
					<th>
						<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffID-->
					<th>
						<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--PersonTypeDesc-->
					<th>
						<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterPersonTypeDesc
									[ngModel]="value"
									[options]="lstPersonTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SchoolFullName-->
					<th>
						<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--UserLevelDesc-->
					<th>
						<p-columnFilter field="UserLevelDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterUserLevelDesc
									[ngModel]="value"
									[options]="lstUserLevelDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--ActiveDesc-->
					<th>
						<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterActiveDesc
									[ngModel]="value"
									[options]="lstActiveDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="UserName">Username<p-sortIcon field="UserName"></p-sortIcon></th>
					<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="PersonTypeDesc">Staff Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="SchoolFullName">Home School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
					<th pSortableColumn="UserLevelDesc">User Level<p-sortIcon field="UserLevelDesc"></p-sortIcon></th>
					<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-User>
				<tr [pSelectableRow]="User">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of UserCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ User[col.field] }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.SameSchool == true ? 'Black' : 'Red'">
						{{ User.SchoolFullName }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.UserLevelID == 1 ? 'Orange' : 'Black'">
						{{ User.UserLevelDesc }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.Active == true ? 'Black' : 'Red'">
						{{ User.ActiveDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
	</div>
</div>
